



















































import { Vue, Component, Prop } from 'vue-property-decorator';
import TabProductsReservation from './TabProductsReservation.vue';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { ProductApi } from '../../models/NDVModalTabs.model';

@Component({ components: { GridComponent: AgGridVue, TabProductsReservation } })
export default class TabProducts extends Vue {
  @Prop({ required: true, default: [] }) data!: ProductApi[];
  @Prop({ required: true, default: '' }) ndv!: string;
  @Prop({ required: true, default: '' }) ndvnumero!: string;
  showReservation: boolean = false;
  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  listData: any = [];
  quickSearch: string = '';

  constructor() {
    super();
    this.columnDefs = this.colsGrid();
    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  handleMainGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData(this.data);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleSearch() {
    this.gridApi.setQuickFilter(this.quickSearch);
    this.gridApi.setDomLayout('autoHeight');
  }
  handleCancel() {
    this.showReservation = false;
  }
  handleOpen() {
    this.showReservation = true;
  }
  private colsGrid(): ColDef[] {
    return Object.keys(this.data[0])
      .filter(
        col =>
          !['ndvnumero', 'ndvorden', 'STATUS', 'TOTAL_REGISTROS'].includes(col)
      )
      .map(col => ({
        headerName: col,
        field: col,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 220,
        minWidth: 100,
      }));
  }
}
